import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import NutritionModalRow from './components/NutritionModalRow';
import useItemNutrition from './hooks/useItemNutrition';

interface Params {
    itemId: string;
}

const ItemNutritionModal: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { itemId } = params;
    const { nutrition, isNutritionExists } = useItemNutrition(itemId);
    const { t } = useTranslation('item');
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={28}>
                    <Column spacing={2} align='center'>
                        <Text size='lg' fontWeight='bold'>{t('nutrition.title')}</Text>
                        {nutrition?.servingSize && (
                            <Text>({nutrition?.servingSize} {t('nutrition.servingSize')})</Text>
                        )}
                    </Column>
                    {(!isNutritionExists) && (
                        <Row fullWidth justify='center'>
                            <Text color={colors.gray6}>{t('nutrition.noData')}</Text>
                        </Row>
                    )}
                    <Column fullWidth spacing={16}>
                        <NutritionModalRow labelKey='calories' value={nutrition?.calories}/>
                        <NutritionModalRow labelKey='sodium' value={nutrition?.sodium}/>
                        <NutritionModalRow labelKey='sugar' value={nutrition?.sugar}/>
                        <NutritionModalRow labelKey='saturatedFat' value={nutrition?.saturatedFat}/>
                        <NutritionModalRow labelKey='protein' value={nutrition?.protein}/>
                        <NutritionModalRow labelKey='caffeine' value={nutrition?.caffeine}/>
                        <NutritionModalRow labelKey='allergy' value={nutrition?.allergyComment}/>
                        <NutritionModalRow labelKey='carbohydrate' value={nutrition?.carbohydrate}/>
                        <NutritionModalRow labelKey='fat' value={nutrition?.fat}/>
                        <NutritionModalRow labelKey='cholesterol' value={nutrition?.cholesterol}/>
                        <NutritionModalRow labelKey='transFat' value={nutrition?.transFat}/>
                        <NutritionModalRow labelKey='origin' value={nutrition?.origin}/>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default ItemNutritionModal;
